import { checkDefined } from '@com-delta-idp/mnx-skymiles-shared';
import { createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters';
import { EDocRequest, TYPE } from '../../models';
import { getOverviewEntities, getSharedEntities } from './common.selectors';

export const getWelcomeTour = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getWelcomeTour(
      overviewEntities['aem-welcome-tour']?.aemWelcomeTour?.tour,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.welcomeTour
    )
);

export const getHeader = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getHeader(
      overviewEntities['aem-content']?.aemContent?.overview.summary.title
    )
);

export const getMicroMoments = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getMicroMoments(
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .microMoments,
      overviewEntities['multiple-pe-content']?.multiplePEContent,
      overviewEntities['status-tracker-content']?.statusTrackerContent,
      sharedEntities['user-session']?.userSession,
      [
        overviewEntities['multiple-pe-content-error']?.multiplePEContentError,
        overviewEntities['status-tracker-content-error']
          ?.statusTrackerContentError
      ]
    )
);

export const getQuickLinks = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getQuickLinks(
      overviewEntities['aem-content']?.aemContent?.quickLinks,
      sharedEntities['user-session']?.userSession,
      overviewEntities['status-tracker-content']?.statusTrackerContent,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.quickLinks,
      [],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getBenefits = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getBenefits(
      overviewEntities['aem-content']?.aemContent?.benefits,
      sharedEntities['user-session']?.userSession,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.benefits,
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getSnapshot = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getSnapshot(
      overviewEntities['aem-content']?.aemContent?.snapshot,
      overviewEntities['snapshot-content']?.snapshotData,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.snapshot,
      [overviewEntities['snapshot-content-error']?.snapshotDataError],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getUpgrades = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    // @TODO: EDocsResponseMocks should be replaced with actual data once we get proper response from API
    Adapters.getUpgrades(
      overviewEntities['aem-content']?.aemContent?.upgrades,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.upgrades,
      overviewEntities['vouchers-content']?.vouchersContent?.voucherCount,
      overviewEntities['eDocs-content']?.eDocsContent,
      [
        overviewEntities['eDocs-content-error']?.eDocsContentError,
        overviewEntities['vouchers-content-error']?.vouchersContentError
      ],
      overviewEntities['aem-error-messages']?.aemErrorMessages
    )
);

export const getStipulation = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getStipulation(
      overviewEntities['aem-content']?.aemContent?.stipulation,
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags
        .termsAndConditions
    )
);

export const getPERequest = createSelector(
  getSharedEntities,
  getOverviewEntities,
  (sharedEntities, overviewEntities) =>
    Adapters.getPERequest(
      overviewEntities['aem-content']?.aemContent?.campaignId,
      sharedEntities['user-session']?.userSession
    )
);

export const getEdocsRequest = createSelector(
  getSharedEntities,
  (sharedEntities) => {
    const request: EDocRequest = {
      loyaltyNumber: checkDefined(
        sharedEntities['user-session']?.userSession?.smNumber
      ),
      requestType: TYPE.REQUEST_TYPE,
      app: TYPE.APP,
      cartId: ''
    };
    return request;
  }
);

export const getWelcomeTourFlag = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.welcomeTour
);

export const getSkyClubRequest = createSelector(
  getSharedEntities,
  (sharedEntities) =>
    Adapters.getSkyClubRequest(sharedEntities['user-session']?.userSession)
);
